import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import {ReactComponent as LocationSVG} from '../assets/svgs/location.svg';
import {ReactComponent as EmailSVG} from '../assets/svgs/email.svg';
import {ReactComponent as PhoneSVG} from '../assets/svgs/phone.svg';
import MapModal from '../components/MapModal';   

const Container = styled.div`
  padding: 100px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  width: fit-content;
  max-width: 80vw;
  margin: 80px 100px 100px;
  place-self: center;

  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: left;

  @media (max-width: 768px) {
    text-align: center;
    margin: 50px 50px 100px;
    padding: 20px;

    p{
     font-size:12px;
    }
  }


`;

const Title = styled.h2`
  color: #385963;
  font-weight: 600;
  text-align: center;
`;


const TermsOfUse = () => {
  const { i18n } = useTranslation();
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';


  return (
    <>
    <Container>
      <Title>{i18n.t('termsOfUse')}</Title>

      
      {selectedLanguage === 'en' ? (
        <p>
          <strong>Privacy Policy and Website Privacy Policy </strong> 
           <br/>
            PIERIAN ORGANIZATION OF TOURISM DEVELOPMENT AND PROMOTION (hereinafter “PTO”), attaches great importance to the lawful collection,
            processing, use, security and protection of your personal data. This applies in any capacity you communicate or collaborate with us,
            such as citizens, website visitors, employees, merchants, suppliers, traders, civil protection volunteers, 
            individuals or cooperating third parties.
           <br/>
           <br/>
           P.O.T.A.P. as Data Controller, which is subject to processing during your browsing on its website through 
           the link www.olympusrivieragreece.gr and remains at your disposal for any clarification.
           <br/>
           <br/>
            The processing of your personal data is carried out with respect to the basic principles of personal data protection,
            which are imposed by the General Data Protection Regulation (EU) 2016/679 (GDPR-GDPR) and the provisions of the Law. 4624/2019 
            “Personal Data Protection Authority, implementing measures of Regulation (EU) 2016/679 of the European Parliament and of the
            Council of 27 April 2016 on the protection of individuals with regard to the processing of personal data and the transposition
            into national law of Directive (EU) 2016/680 of the European Parliament and of the Council of of 27 April 2016 and other
            provisions’ (A’ 137), namely the lawfulness, objectivity and transparency, the minimization and accuracy of data, the limitation of the purpose of processing, the limitation of the period of storage, the integrity and confidentiality and, finally, the principle of accountability.
           <br/>
           <br/>
           Please take a moment to read carefully this Privacy Policy and Privacy Policy of this website.
           <br/>
           <br/>
           1. The website
           <br/>
           <br/>
           The website www.olympusrivieragreece.gr is the website of the PIERIKOS TOURISM DEVELOPMENT AND PROMOTION ORGANIZATION.
           <br/>
           <br/>
           The website provides informative content and hosts a wide range of information provided to citizens.
           <br/>
           <br/>
           2. What kind of personal data are we processing?
           <br/>
           <br/>
           While browsing the website, we may collect non-personal identification information through the use of cookies. Cookies are small text files that are stored on your hard drive and do not take cognizance of any document or file from your computer, nor do they lead to the identification of your computer with any person. During your visit to the website you can configure its browser in such a way that it either warns you about the use of "cookies" in certain services or does not allow the use of "cookies" under any circumstances. In this case, in which specific services and pages do not wish to use "cookies" to identify you, you may have limited access to some of the services, uses or functions provided by this website.
           <br/>
           <br/>
           You can receive detailed information about the website's terms of use and cookies policy by reading them in the Cookies Policy and Terms of Use link.
           <br/>
           <br/>
           3. Legal basis for processing
           <br/>
           <br/>
           You expressly and unconditionally consent to having the above personal information on the website, where required or requested. To the extent that the processing of your personal data is based on consent, you can withdraw at any time by informing the controller. Withdrawal of consent shall not affect the lawfulness of processing carried out prior to withdrawal.
           <br/>
           <br/>
           4. Who has access to your personal data?
           <br/>
           <br/>
           Access to your personal data has the necessary, in any case, staff of the P.O.T.A.P., who has received the appropriate information for the safe processing of your personal data.
           We do not transfer or disclose your personal information received through the website to third parties, unless otherwise provided by law or if it is a contractual obligation necessary for the proper functioning of the website and the realization of its functions.
           <br/>
           <br/>       
           5. Transmission of personal data
           <br/>
           <br/>
           We do not send your data outside Greece. Your personal data is stored and processed only in Greece.
           <br/>
           <br/>
           6. Time period for keeping your personal data
           <br/>
           <br/>
           Your personal data is retained for five years.
           <br/>
           <br/>
           7. Connection to third party websites
           <br/>
           <br/>
           Any interconnection of this Website with another third party website through special links, hyperlinks (links, hyperlinks, banners, etc.) does not imply that POTAP assumes any responsibility for the content of this other website, the quality and completeness of any products or services presented therein or the policy followed on the protection and processing of personal data. The natural person should ensure that he or she is informed about the protection and processing of his or her data from the above websites and read the respective privacy policies that apply to them.
           <br/>
           <br/>
           8. The Security of Your Data
           <br/>
           <br/>
           We are committed to taking appropriate organizational and technical measures to ensure the security and protection of your data from any form of accidental or unlawful processing. The measures we take are reviewed and amended when necessary.
           <br/>
           <br/>
           9. Your rights as data subjects
           <br/>
           <br/>
           As a Rights Holder you have the following rights:
           <br/>
           <br/>
            A. Right of information and transparency
             <br/>
            You have the right to know who is processing your data, what they are and why.
            <br/>
             <br/>
            B. Right of access to personal data
             <br/>
            You have the right to request free access to our personal data. This means that you have the right to ask us for confirmation as to whether we are processing your data.
             <br/>
              <br/>
             C. Right to rectify inaccurate personal data.
              <br/>
            You have the right to request the correction of inaccurate personal data and filling in incomplete data (e.g. name correction or update of a change of telephone number).
             <br/>
              <br/>
             D. Right to erasure (“right to be forgotten”)
              <br/>
            You have the right to request the deletion of your personal data, under certain conditions, such as when the data is no longer necessary, you have revoked your consent, the data has been illegally processed, and so on.
           <br/>
            <br/>
             E. Right to restrict processing.
              <br/>
            You have the right to request the restriction of the processing of your personal data when their accuracy is questioned, the processing is illegal, the data is no longer needed by the controller or you object to automated processing.
             <br/>
              <br/>
            F. Right to object to the processing of your data.
             <br/>
            You may object to the processing of your data and we will stop the processing of your data, unless such processing is carried out on the legal basis of our legitimate interest or public interest, or if there are other compelling and legitimate reasons that prevail over your right.
            <br/>
            <br/>
            10. How can you exercise your rights?
            <br/>
            <br/>
            If you wish to receive further information about the processing of your personal data or exercise any of the above rights, you can contact the Data Protection Officer at: potap.pieria@gmail.com or send a letter with a description of your Request to the mailing address: 28th October 40, ZIP Code 601 32 – Katerini, Pieria, by writing on the physical file “Be Responsible for Personal Data Protection”. We will take care to examine it and respond to you as soon as possible, within the legal deadlines as follows:
            <br/>
            <br/>
            Our response to your request will take place within one (1) month of receiving it and does not entail any costs for you. The above deadline may be extended for a further two (2) months due to the complexity or number of requests, in which case you will be informed of the extension and its reasons as soon as possible and at the latest within one month of receipt of the request.
             <br/>
            <br/>        
            · In cases where the request will be considered manifestly unfounded or excessive, in particular due to its recurring nature, the P.O.T.A.P. may either refuse to continue the processing of the request, or impose a reasonable fee for its processing taking into account the administrative costs for providing the information or performing the requested action.
             <br/>
            <br/>
            · In the event that: a. you consider that your request has not been adequately and lawfully fulfilled or b. you consider that the right to the protection of your personal data is infringed by a processing that we carry out, you have the right to submit a complaint to the Personal Data Protection Authority electronically through its web portal at https://eservices.dpa.gr/ by completing the corresponding electronic form depending on the type of complaint (Further contact details with the Personal Data Protection Authority: postal address: Kifissias 1-3, 115 23, Athens, Greece, tel. 210 6475600, e-mail address: contact@dpa.gr).
            <br/>
            <br/>
            11. Change of Policy
            <br/>
            <br/>
            We will update this Policy whenever necessary by incorporating the amendments at www.olympusrivieragreece.gr. If there are significant changes in the Policy or in the way we use your Personal Data, we will notify you either by posting a notice in a prominent place, once the changes take effect, or in any other appropriate way. We encourage you to review this Policy regularly to know how your data is protected.
             <br/>
            <br/>
            Last revised: 31-10-2025





        </p>
      ) : selectedLanguage === 'gr' ? (
        <p>
           <strong>Πολιτική Απορρήτου και 
Πολιτική Προστασίας Προσωπικών Δεδομένων Ιστοτόπου</strong> 
           <br/>
            Ο ΠΙΕΡΙΚΟΣ ΟΡΓΑΝΙΣΜΟΣ ΤΟΥΡΙΣΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΚΑΙ ΠΡΟΒΟΛΗΣ (εφεξής «Π.Ο.Τ.Α.Π.»), αποδίδει μεγάλη σημασία στη σύννομη συλλογή, επεξεργασία, χρήση, ασφάλεια και προστασία των προσωπικών σας δεδομένων. Αυτό ισχύει υπό οποιαδήποτε ιδιότητα επικοινωνείτε ή συνεργάζεστε μαζί μας, όπως για παράδειγμα ως πολίτες, επισκέπτες ιστοσελίδας, εργαζόμενοι, έμποροι, προμηθευτές, επιτηδευματίες, εθελοντές πολιτικής προστασίας, ιδιώτες ή συνεργαζόμενοι τρίτοι.
           <br/>
           <br/>
            Ο Π.Ο.Τ.Α.Π. ως Υπεύθυνος Επεξεργασίας των δεδομένων που υπόκεινται σε επεξεργασία κατά την πλοήγησή σας στον διαδικτυακό ιστότοπό του μέσω του συνδέσμου www.olympusrivieragreece.gr και παραμένει στη διάθεσή σας για οποιαδήποτε διευκρίνιση.
           <br/>
           <br/>
           Η επεξεργασία των προσωπικών σας δεδομένων πραγματοποιείται με σεβασμό προς τις βασικές αρχές προστασίας προσωπικών δεδομένων, τις οποίες επιβάλλει ο Γενικός Κανονισμός για την Προστασία Δεδομένων (ΕΕ) 2016/679 (ΓΚΠΔ-GDPR) και οι διατάξεις του ν. 4624/2019 «Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα, μέτρα εφαρμογής του Κανονισμού (ΕΕ) 2016/679 του Ευρωπαϊκού Κοινοβουλίου και του Συμβουλίου της 27ης Απριλίου 2016 για την προστασία των φυσικών προσώπων έναντι της επεξεργασίας δεδομένων προσωπικού χαρακτήρα και την ενσωμάτωση στην εθνική νομοθεσία της Οδηγίας (ΕΕ) 2016/680 του Ευρωπαϊκού Κοινοβουλίου και του Συμβουλίου της 27ης Απριλίου 2016 και άλλες διατάξεις» (Α΄ 137), ήτοι τη νομιμότητα, αντικειμενικότητα και διαφάνεια, την ελαχιστοποίηση, και την ακρίβεια των δεδομένων, τον περιορισμό του σκοπού της επεξεργασίας, τον περιορισμό της περιόδου αποθήκευσης, την ακεραιότητα και εμπιστευτικότητα και, τέλος, την αρχή της λογοδοσίας.
           <br/>
           <br/>
           Παρακαλούμε να αφιερώσετε λίγο χρόνο για να διαβάσετε προσεκτικά την παρούσα Πολιτική Απορρήτου και Πολιτική Προστασίας Προσωπικών Δεδομένων του παρόντα ιστοτόπου.
           <br/>
           <br/>
           1. Ο ιστότοπος
           <br/>
           <br/>       
            Ο ιστότοπος www.olympusrivieragreece.gr αποτελεί τον διαδικτυακό τόπο του ΠΙΕΡΙΚΟΥ ΟΡΓΑΝΙΣΜΟΥ ΤΟΥΡΙΣΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΚΑΙ ΠΡΟΒΟΛΗΣ.
           <br/>
           <br/>
            Ο ιστότοπος παρέχει ενημερωτικό περιεχόμενο και φιλοξενεί ένα ευρύ φάσμα παρεχόμενων πληροφοριών προς τους πολίτες.
           <br/>
           <br/>
           2. Τι είδους προσωπικά δεδομένα επεξεργαζόμαστε;
           <br/>
           <br/>
           Κατά την πλοήγησή σας στον ιστότοπο ενδέχεται να συγκεντρώνουμε μη προσωπικά στοιχεία αναγνώρισής σας μέσω της χρήσης cookies. Τα cookies είναι μικρά αρχεία κειμένου που αποθηκεύονται στο σκληρό δίσκο σας και δεν λαμβάνουν γνώση οποιουδήποτε εγγράφου ή αρχείου από τον υπολογιστή σας, ούτε και οδηγούν στην ταυτοποίηση του υπολογιστή σας με οποιοδήποτε πρόσωπο. Κατά την επίσκεψή σας στον ιστότοπο μπορείτε να ρυθμίσετε το πρόγραμμά πλοήγησής του με τρόπο ώστε είτε να σας προειδοποιεί για τη χρήση “cookies” σε συγκεκριμένες υπηρεσίες είτε να μην επιτρέπει την αποδοχή της χρήσης “cookies” σε καμία περίπτωση. Σε αυτή την περίπτωση κατά την οποία σε συγκεκριμένες υπηρεσίες και σελίδες, δεν επιθυμείτε τη χρήση “cookies” για την αναγνώρισή σας, ενδέχεται να έχετε περιορισμένη πρόσβαση σε μερικές από τις υπηρεσίες, χρήσεις ή λειτουργίες που παρέχονται από τον παρόντα ιστότοπο.
           <br/>
           <br/>     
            Μπορείτε να λάβετε αναλυτική ενημέρωση για τους όρους χρήσης και της πολιτικής cookies του ιστοτόπου, διαβάζοντάς τους στον σύνδεσμο Πολιτική Cookies και Όροι Χρήσης.
           <br/>
           <br/>
           3. Νομική βάση επεξεργασίας
           <br/>
           <br/>
            Συγκατατίθεστε ρητά και ανεπιφύλακτα να διαθέτετε τα παραπάνω προσωπικά σας στοιχεία στον ιστότοπο, όπου αυτό απαιτείται ή σας ζητηθεί. Στον βαθμό που η επεξεργασία των προσωπικών σας δεδομένων βασίζεται στη συγκατάθεση, μπορείτε να ανακαλέσετε ανά πάσα στιγμή ενημερώνοντας τον υπεύθυνο επεξεργασίας. Η ανάκληση της συγκατάθεσης δεν θίγει τη νομιμότητα της επεξεργασίας που πραγματοποιήθηκε πριν από την απόσυρση.
           <br/>
           <br/>
           4. Ποιοί έχουν πρόσβαση στα προσωπικά σας δεδομένα;
           <br/>
           <br/>
           Πρόσβαση στα προσωπικά σας δεδομένα έχει το απαραίτητο, σε κάθε περίπτωση, προσωπικό του Π.Ο.Τ.Α.Π., το οποίο έχει λάβει τη δέουσα ενημέρωση για την ασφαλή επεξεργασία των προσωπικών σας δεδομένων.
           <br/>
            Δεν μεταφέρουμε ή δεν δημοσιοποιούμε προσωπικά στοιχεία σας που έχουν ληφθεί μέσω του ιστοτόπου σε τρίτους, εκτός εάν νόμος ορίζει διαφορετικά ή αν αποτελεί συμβατική υποχρέωση απαραίτητη για την εύρυθμη λειτουργία του ιστοτόπου και την πραγματοποίηση των λειτουργιών του.
           <br/>
           <br/>       
           5. Διαβίβαση προσωπικών δεδομένων
           <br/>
           <br/>
           Δεν αποστέλλουμε τα δεδομένα σας εκτός Ελλάδας. Τα προσωπικά σας δεδομένα αποτελούν αντικείμενο αποθήκευσης και επεξεργασίας μόνο εντός Ελλάδας.
           <br/>
           <br/>
           6. Χρονική περίοδος τήρησης των προσωπικών σας δεδομένων
           <br/>
           <br/>
           Τα προσωπικά σας δεδομένα διατηρούνται για πέντε χρόνια.
           <br/>
           <br/>
           7. Σύνδεση με διαδικτυακούς τόπους τρίτων
           <br/>
           <br/>
           Η τυχόν διασύνδεση του παρόντος Διαδικτυακού Τόπου με άλλο διαδικτυακό τόπο τρίτων μερών μέσω ειδικών συνδέσμων, υπερσυνδέσμων (links, hyperlinks, banners κ.λπ.) δεν συνεπάγεται την εκ μέρους του ΠΟΤΑΠ ανάληψη οιασδήποτε ευθύνης για το περιεχόμενο του έτερου αυτού διαδικτυακού τόπου, την ποιότητα και την πληρότητα των τυχόν προϊόντων ή των υπηρεσιών που παρουσιάζονται σε αυτόν ή την πολιτική που ακολουθείται σε αυτόν σχετικά με την προστασία και επεξεργασία των δεδομένων προσωπικού χαρακτήρα. Το φυσικό πρόσωπο θα πρέπει να φροντίζει το ίδιο να ενημερώνεται για την προστασία και την επεξεργασία των δεδομένων του από τους ανωτέρω διαδικτυακούς τόπους και να διαβάζει τις αντίστοιχες πολιτικές προστασίας προσωπικών δεδομένων/απορρήτου που ισχύουν σε αυτούς.
           <br/>
           <br/>
           8. Η Ασφάλεια των δεδομένων σας
           <br/>
           <br/>
           Δεσμευόμαστε ότι έχουμε λάβει κατάλληλα οργανωτικά και τεχνικά μέτρα για την ασφάλεια και την προστασία των δεδομένων σας από κάθε μορφής τυχαία ή αθέμιτη επεξεργασία. Τα μέτρα που λαμβάνουμε, επανεξετάζονται και τροποποιούνται όταν κρίνεται απαραίτητο.
           <br/>
           <br/>
           9.Τα δικαιώματά σας ως υποκείμενα των δεδομένων
           <br/>
           <br/>
           Ως Υποκείμενο των Δικαιωμάτων έχετε τα ακόλουθα δικαιώματα:
           <br/>
           <br/>
            Α. Δικαίωμα ενημέρωσης και διαφάνεια
            <br/>
            Έχετε το δικαίωμα να γνωρίζετε ποιος επεξεργάζεται τα δεδομένα σας, ποια είναι αυτά και για ποιον λόγο.
            <br/>
            <br/>
             Β. Δικαίωμα πρόσβασης στα προσωπικά δεδομένα
             <br/>
             Έχετε το δικαίωμα να ζητήσετε δωρεάν πρόσβαση στα προσωπικά σας δεδομένα που διαθέτουμε. Αυτό σημαίνει ότι έχετε το δικαίωμα να ζητήσετε επιβεβαίωση από εμάς για το εάν επεξεργαζόμαστε δεδομένα σας. 
             <br/>
             <br/>
             Γ. Δικαίωμα διόρθωσης ανακριβών δεδομένων προσωπικού χαρακτήρα.
            <br/>
             Έχετε το δικαίωμα να ζητήσετε τη διόρθωση ανακριβών προσωπικών δεδομένων και συμπλήρωσης ελλιπών στοιχείων (π.χ. διόρθωση ονόματος ή ενημέρωση αλλαγής τηλεφωνικού αριθμού).
             <br/>
             <br/>
             Δ. Δικαίωμα διαγραφής («δικαίωμα στη λήθη»)
             <br/>
             Έχετε το δικαίωμα να ζητήσετε τη διαγραφή προσωπικών σας δεδομένων, υπό ορισμένες προϋποθέσεις, όπως όταν τα δεδομένα δεν είναι πλέον απαραίτητα, έχετε ανακαλέσει τη συγκατάθεσή σας, τα δεδομένα έχουν υποβληθεί σε παράνομη επεξεργασία, κ.ο.κ. 
            <br/>
            <br/>
            Ε. Δικαίωμα περιορισμού της επεξεργασίας.
             <br/>
            Έχετε το δικαίωμα να ζητήσετε τον περιορισμό της επεξεργασίας των προσωπικών σας δεδομένων όταν αμφισβητείται η ακρίβειά τους, η επεξεργασία είναι παράνομη, τα δεδομένα δεν χρειάζονται πλέον στον υπεύθυνο επεξεργασίας ή έχετε αντιρρήσεις ως προς την αυτοματοποιημένη επεξεργασία.
            <br/>
            <br/>
            ΣΤ. Δικαίωμα εναντίωσης στην επεξεργασία των δεδομένων σας.
            <br/>
            Μπορείτε να αντιταχθείτε στην επεξεργασία των δεδομένων σας και εμείς θα σταματήσουμε την επεξεργασία των δεδομένων σας, εκτός εάν αυτή η επεξεργασία πραγματοποιείται στην νομική βάση του εννόμου συμφέροντός μας ή του δημοσίου συμφέροντος, ή εάν υφίστανται άλλοι επιτακτικοί και νόμιμοι λόγοι που υπερισχύουν έναντι του δικαιώματός σας.
            <br/>
            <br/>
            10. Πώς μπορείτε να ασκήσετε τα δικαιώματα σας;
            <br/>
            <br/>
            Εάν επιθυμείτε να λάβετε περαιτέρω πληροφορίες σχετικά με την επεξεργασία των προσωπικών σας δεδομένων ή να ασκήσετε οποιοδήποτε εκ των ανωτέρω δικαιωμάτων, μπορείτε να επικοινωνήσετε με τον Υπεύθυνο Προστασίας Δεδομένων στη διεύθυνση ηλεκτρονικού ταχυδρομείου: potap.pieria@gmail.com  είτε να αποστείλετε επιστολή με περιγραφή του Αιτήματός σας στη διεύθυνση αλληλογραφίας: 28ης Οκτωβρίου 40, ΤΚ 601 32 – Κατερίνη, Πιερία, αναγράφοντας επί του φυσικού φακέλου «Υπόψιν Υπεύθυνου για Προστασία Προσωπικών Δεδομένων». Εμείς θα φροντίσουμε να το εξετάσουμε και να σας απαντήσουμε το συντομότερο δυνατό, εντός των νόμιμων προθεσμιών ως εξής:
            <br/>
            <br/>
           Η απάντησή μας στο αίτημά σας θα λάβει χώρα εντός ενός (1) μηνός από τη λήψη του και δεν συνεπάγεται κανένα κόστος για εσάς. Η ανωτέρω προθεσμία μπορεί να παραταθεί για χρονικό διάστημα δύο (2) επιπλέον μηνών λόγω της πολυπλοκότητας ή του αριθμού των αιτημάτων, περίπτωση κατά την οποία θα ενημερωθείτε για την παράταση και τους λόγους αυτής το ταχύτερο δυνατό και το αργότερο εντός μήνα από την παραλαβή του αιτήματος.
             <br/>
            <br/>        
          · Στις περιπτώσεις που το αίτημα θα κριθεί προδήλως αβάσιμο ή υπερβολικό,  ιδίως λόγω του επαναλαμβανόμενου χαρακτήρα του, o Π.Ο.Τ.Α.Π.  δύναται είτε να αρνηθεί τη συνέχιση της διεκπεραίωσης του αιτήματος, είτε να επιβάλει την καταβολή εύλογου τέλους για τη διεκπεραίωσή του λαμβάνοντας υπόψη τα διοικητικά έξοδα για την παροχή της ενημέρωσης ή την εκτέλεση της ζητούμενης ενέργειας.
             <br/>
            <br/>
            · Στην περίπτωση που: α. θεωρείτε πως δεν ικανοποιήθηκε επαρκώς και νομίμως κάποιο αίτημά σας ή β. θεωρείτε πως το δικαίωμα στην προστασία των προσωπικών σας δεδομένων προσβάλλεται από κάποια επεξεργασία που πραγματοποιούμε, έχετε δικαίωμα να υποβάλετε καταγγελία στην Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα ηλεκτρονικά μέσω της διαδικτυακής της πύλης στον σύνδεσμο  https://eservices.dpa.gr/ με τη συμπλήρωση της αντίστοιχης ηλεκτρονικής φόρμας ανάλογα με τον τύπο της καταγγελίας (Περαιτέρω στοιχεία επικοινωνίας με την Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα: ταχυδρομική δ/νση: Κηφισίας 1-3, Τ.Κ. 115 23, Αθήνα, τηλ. 210 6475600, δ/νση ηλεκτρονικού ταχυδρομείου e-mail: contact@dpa.gr).
            <br/>
            <br/>
            13. Αλλαγή της Πολιτικής
            <br/>
            <br/>
            Θα ενημερώνουμε την παρούσα Πολιτική όποτε αυτό κριθεί αναγκαίο, ενσωματώνοντας τις τροποποιήσεις στον ιστότοπο www.olympusrivieragreece.gr. Εάν υπάρχουν σημαντικές αλλαγές στην Πολιτική ή στον τρόπο με τον οποίο χρησιμοποιούμε τα Προσωπικά Δεδομένα σας, θα σας ειδοποιούμε είτε δημοσιεύοντας μια ειδοποίηση σε εμφανές σημείο, μόλις οι αλλαγές τεθούν σε ισχύ, είτε με κάθε άλλον πρόσφορο τρόπο. Σας ενθαρρύνουμε να διαβάζετε ανά τακτά διαστήματα την παρούσα Πολιτική για να γνωρίζετε πώς προστατεύονται τα δεδομένα σας.
             <br/>
            <br/>
            Τελευταία αναθεώρηση: 31-10-2025
        </p>
      ) : null}

  
    </Container>





 <Container>
      <Title>{i18n.t('cookiePolicy')}</Title>

      
      {selectedLanguage === 'en' ? (
        <p>
          <strong> Cookies Policy</strong> 
           <br/>
             At www.olympusrivieragreece.gr (from now on “website”) we use various technologies to collect information to improve your online experience.
            <br/> 
            <br/>
            In this Cookie Policy, we refer to these technologies, which include cookies, pixels and gifs (together "Cookies"). This Policy explains the different types of Cookies used on the website and how to control them. We reserve the right to change this Cookie Policy at any time. We recommend that you check at the top of the site the date from which the Policy applies. Any changes will take effect once the revised Policy is available on the website. By consenting to the use of Cookies you can navigate better. We hope that this Policy helps you understand and feel more secure about our use of Cookies. If you have any further questions, please contact us at: potap.pieria@gmail.com
            <br/> 
            <br/>
            About cookies
            <br/> 
            Cookies are small text files with information, which are stored by the server (server) of a website on your terminal device (computer, mobile phone, etc.) when navigating to it. The website retrieves this information at each visit in order to offer services related to them. A typical example of such information is your preferences on a website, as stated by the choices you make (e.g. selecting specific “buttons”, searches, etc.).
            <br/> 
            In accordance with Article 4 par. 5 of Law 3471/2006 the storage or access to stored information in your terminal equipment is allowed only if you have given your consent after clear and extensive information. An exception to the obligation to obtain consent under the above paragraph is the storage and access of information for the sole purpose of ‘carrying out the transmission of a communication over an electronic communications network or necessary for the provision of an information society service explicitly requested by the user or subscriber’. Your consent is essentially not required for Cookies which are considered technically necessary for the connection to the website or for the provision of the internet service.
            <br/> 
            Cookies may be installed by the provider of the website you visit (first party cookies) or by others through the provider of the website (third party cookies) you visit.
            <br/> 
            <br/>
            Cookie Management through the browser
            <br/>
             You can set your web browser in such a way that it warns you about the use of Cookies and does not allow them to be accepted under any circumstances. In this case some services and functions may not work. Of course, not choosing this setting is not interpreted as your will to accept all Cookies without exception.
            <br/>
             You can also delete all Cookies already on your device by deleting your browser's browsing history. This will delete all Cookies from all the websites you visited from this browser. But keep in mind that some stored data (e.g. saved login information, site preferences) may also be lost.
            <br/>
             To manage and deactivate Cookies, you can follow the relevant instructions for each type of browser:
            <br/> 
            <br/>
            Microsoft Edge
            <br/>
            Internet Explorer
            <br/>
            Mozilla Firefox
            <br/>
            Google Chrome
            <br/>
            Safari
            <br/>
            Opera
             <br/> 
            <br/>
            Website Cookie Categories and Settings
            <br/> 
            Your cookie preferences can be managed through the Cookie Banner (Information Box) which is available in the footer (footer) of the website.
            We use the Cookies necessary to maintain your connection to our online services and to store your options in relation to optional Cookies (“Necessary”).
            <br/> 
            With your consent we will use additional optional cookies to measure and analyze traffic in order to improve the performance and content of the website.
            <br/> 
            We then provide information for each category of Cookies. By default, the default of optional Cookies is disabled and enabled only with your positive action.
            <br/>
            <br/>  
             Necessary Cookies
            <br/> 
            Cookies of this category are necessary for the proper and effective operation of the website. They store information about your preferences regarding the use of optional Cookies. The use of mandatory Cookies does not require your consent.
            <br/>
            <br/>  
           Traffic measurement and analysis cookies
            <br/>  
           Cookies of this category are used to obtain statistics on traffic to the website for the sole purpose of improving its performance and content, provided that you have already given your consent.
           For the above purpose we use the Google Analytics service. With this function, the IP address when you access the website of the P.O.T.A.P. is stored.
            <br/>  
           The information collected relates to how you browse the site, such as the frequency of your visit to the pages, the keywords you use to search, the type of program you use to browse and the website from which your visit originated. These statistics do not identify you, are not used for any other purpose and are not shared with third parties.
            <br/>
            <br/>  
           Log files
           <br/>
           The following information is recorded in log files for each request to the site server by your browser:
           <br/>
           · the IP address, which is your personal data, even if we cannot identify you by ourselves based on this data,
           <br/>
           · the URL you wish to access and the relevant date
           <br/>
           · error file
           <br/>
          The above data is collected to check the security of the website's information and services, to ensure the availability, integrity and confidentiality of the information and data from accidental or unlawful or malicious actions or events, to investigate any online attacks and incidents and to support any relevant legal claims.
           <br/>
           The logs may be shared with the processing companies for the purpose of managing the website and with the competent authorities in case it is necessary to investigate any online attack and incident.
           <br/>
           <br/> 
           Last revised: 31-10-2025    




        </p>
      ) : selectedLanguage === 'gr' ? (
        <p>
           <strong>Πολιτική Cookies</strong> 
            <br/>
            Στον ιστότοπο www.olympusrivieragreece.gr (από εδώ και στο εξής «ιστότοπος») χρησιμοποιούμε διάφορες τεχνολογίες για να συλλέξουμε πληροφορίες για να βελτιώσουμε τη διαδικτυακή εμπειρία σας.
            <br/> 
            <br/>
            Στη συγκεκριμένη Πολιτική Cookies, αναφερόμαστε σε αυτές τις τεχνολογίες, οι οποίες περιλαμβάνουν cookies, pixels και gifs (από κοινού «Cookies»). Η παρούσα Πολιτική εξηγεί τα διαφορετικών ειδών Cookies που χρησιμοποιούνται στον ιστότοπο και τον τρόπο ελέγχου τους. Διατηρούμε το δικαίωμα να αλλάξουμε την παρούσα Πολιτική Cookies οποιαδήποτε στιγμή. Συνιστούμε να ελέγχετε στην κορυφή του ιστοτόπου την ημερομηνία από την οποία ισχύει η Πολιτική. Οποιεσδήποτε αλλαγές θα ισχύσουν από τη στιγμή που η αναθεωρημένη Πολιτική καταστεί διαθέσιμη στον ιστότοπο. Συναινώντας στη χρήση των Cookies μπορείτε να πλοηγηθείτε καλύτερα. Ευελπιστούμε ότι η παρούσα Πολιτική σας βοηθά να κατανοήσετε και να αισθάνεστε πιο ασφαλείς, σχετικά με την χρήση από μέρους μας των Cookies. Εάν έχετε οποιεσδήποτε περαιτέρω απορίες, παρακαλούμε όπως επικοινωνήσετε μαζί μας στην ηλεκτρονική διεύθυνση: potap.pieria@gmail.com
            <br/> 
            <br/>
            Πληροφορίες για τα cookies
            <br/> 
            Τα Cookies είναι μικρά αρχεία κειμένου με πληροφορίες, τα οποία αποθηκεύονται από τον διακομιστή (server) ενός ιστοτόπου στην τερματική συσκευή (υπολογιστής, κινητό τηλέφωνο κλπ.) σας κατά την πλοήγηση σε αυτόν. Ο ιστότοπος ανακτά τις εν λόγω πληροφορίες σε κάθε επίσκεψη προκειμένου να προσφέρει σχετικές με αυτές υπηρεσίες. Χαρακτηριστικό παράδειγμα τέτοιων πληροφοριών είναι οι προτιμήσεις σας σε έναν ιστότοπο, όπως αυτές δηλώνονται από τις επιλογές που κάνετε (π.χ. επιλογή συγκεκριμένων «κουμπιών», αναζητήσεων κ.λπ.).
             <br/> 
            Σύμφωνα με το άρθρο 4 παρ. 5 του Ν.3471/2006 η αποθήκευση ή η απόκτηση πρόσβασης σε αποθηκευμένες πληροφορίες στον τερματικό εξοπλισμό σας επιτρέπεται μόνο αν εσείς έχετε δώσει τη συγκατάθεσή σας μετά από σαφή και εκτενή ενημέρωση. Εξαίρεση στην υποχρέωση λήψης συγκατάθεσης, σύμφωνα με την ως άνω παράγραφο, αποτελεί η περίπτωση αποθήκευσης και πρόσβασης σε πληροφορίες που έχουν ως αποκλειστικό σκοπό τη «διενέργεια της διαβίβασης μίας επικοινωνίας μέσω δικτύου ηλεκτρονικών επικοινωνιών ή είναι αναγκαία για την παροχή υπηρεσίας της κοινωνίας της πληροφορίας, την οποία έχει ζητήσει ρητά ο χρήστης ή ο συνδρομητής». Ουσιαστικά δεν απαιτείται η συγκατάθεση σας για τα Cookies τα οποία θεωρούνται τεχνικώς απαραίτητα για την πραγματοποίηση της σύνδεσης στον ιστότοπο ή για την παροχή της υπηρεσίας διαδικτύου.
             <br/> 
            Τα Cookies μπορεί να εγκαθίστανται από τον ίδιο τον πάροχο του ιστοτόπου που επισκέπτεστε (first party cookies) ή από άλλους μέσω του παρόχου του ιστοτόπου (third party Cookies) που επισκέπτεστε.
            <br/> 
            <br/>
            Διαχείριση Cookies μέσω του φυλλομετρητή (browser)
            <br/>
            Μπορείτε να ρυθμίσετε το πρόγραμμα της περιήγησής σας στο διαδίκτυο κατά τέτοιο τρόπο ώστε να σας προειδοποιεί για τη χρήση των Cookies και να μην επιτρέπει την αποδοχή τους σε καμία περίπτωση. Στην περίπτωση αυτή ορισμένες υπηρεσίες και λειτουργίες ενδέχεται να μη λειτουργούν. Φυσικά, η μη επιλογή αυτής της ρύθμισης δεν ερμηνεύεται ως βούλησή σας για αποδοχή όλων ανεξαιρέτως των Cookies.
            <br/>
            Μπορείτε επίσης να διαγράψετε όλα τα Cookies που βρίσκονται ήδη στη συσκευή σας διαγράφοντας το ιστορικό περιήγησης του προγράμματος περιήγησής σας. Με αυτόν τον τρόπο θα διαγραφούν όλα τα Cookies από όλους τους ιστότοπους που επισκεφθήκατε από το συγκεκριμένο πρόγραμμα περιήγησης. Να έχετε όμως υπόψη ότι ενδέχεται να χαθούν και ορισμένα αποθηκευμένα στοιχεία (π.χ. αποθηκευμένα στοιχεία σύνδεσης, προτιμήσεις ιστοτόπου).
            <br/>
            Για να διαχειριστείτε και να απενεργοποιήσετε τα Cookies, μπορείτε να ακολουθήσετε τις σχετικές οδηγίες για κάθε τύπο προγράμματος περιήγησης:
            <br/> 
            <br/>
            Microsoft Edge
            <br/>
            Internet Explorer
            <br/>
            Mozilla Firefox
            <br/>
            Google Chrome
            <br/>
            Safari
            <br/>
            Opera
             <br/> 
            <br/>
            Κατηγορίες Cookies Ιστοτόπου και Ρυθμίσεις
            <br/> 
            Η διαχείριση των προτιμήσεών σας για τα cookies μπορεί να γίνει μέσω του Cookie Banner (Ενημερωτικού Πλαισίου) το οποίο είναι διαθέσιμο στο footer (υποσέλιδο) του ιστοτόπου.
            Χρησιμοποιούμε τα Cookies που είναι αναγκαία για τη διατήρηση της σύνδεσης  σας στις ηλεκτρονικές μας υπηρεσίες και για την αποθήκευση των επιλογών σας  σε σχέση με τα προαιρετικά Cookies («Αναγκαία»).
            <br/> 
            Με τη συγκατάθεσή σας  θα χρησιμοποιήσουμε επιπρόσθετα προαιρετικά Cookies για τη μέτρηση και ανάλυση της επισκεψιμότητας με σκοπό τη βελτίωση της επίδοσης και του περιεχομένου του ιστοτόπου. 
            <br/> 
            Στη συνέχεια παρέχουμε πληροφορίες για κάθε κατηγορία Cookies. Εξ ορισμού η προεπιλογή των προαιρετικών Cookies είναι απενεργοποιημένη και ενεργοποιείται μόνο με θετική ενέργειά σας.
            <br/>
            <br/>  
            Αναγκαία Cookies
            <br/> 
            α Cookies αυτής της κατηγορίας είναι απαραίτητα για την ορθή και αποτελεσματική λειτουργία του ιστοτόπου. Αποθηκεύουν πληροφορίες σχετικά με τις προτιμήσεις σας όσον αφορά τη χρήση των προαιρετικών Cookies. Για την χρήση των υποχρεωτικών Cookies δεν απαιτείται η συγκατάθεσή σας. 
            <br/>
            <br/>  
            Cookies μέτρησης και ανάλυσης επισκεψιμότητας
            <br/>  
            Τα Cookies αυτής της κατηγορίας χρησιμοποιούνται για να λαμβάνουμε στατιστικά στοιχεία σχετικά με την επισκεψιμότητα στον ιστότοπο με αποκλειστικό σκοπό τη βελτίωση της επίδοσης και του περιεχομένου του, υπό την προϋπόθεση ότι έχετε ήδη συγκατατεθεί.
            Για τον παραπάνω σκοπό χρησιμοποιούμε την υπηρεσία Google Analytics. Με τη συγκεκριμένη λειτουργία, η διεύθυνση IP κατά την πρόσβασή σας στον ιστότοπο του Π.Ο.Τ.Α.Π. αποθηκεύεται.
            <br/>  
            Οι πληροφορίες που συλλέγονται αφορούν τον τρόπο περιήγησής σας στον ιστότοπο, όπως η συχνότητα της επίσκεψής σας στις σελίδες, οι λέξεις-κλειδιά που χρησιμοποιείτε για την αναζήτηση, ο τύπος του προγράμματος που χρησιμοποιείτε για την περιήγησή σας και ο ιστότοπος από τον οποίο προήλθε η επίσκεψή σας. Τα εν λόγω στατιστικά στοιχεία δεν σας ταυτοποιούν, δεν χρησιμοποιούνται για άλλο σκοπό και δεν κοινοποιούνται σε τρίτους.
            <br/>
            <br/>  
            Αρχεία καταγραφής (log files)
           <br/>
           Τα παρακάτω στοιχεία καταγράφονται σε αρχεία καταγραφής (log files) για κάθε αίτημα στον εξυπηρετητή του ιστοτόπου από το πρόγραμμα περιήγησής σας:
           <br/>
           • η διεύθυνση IP, η οποία αποτελεί προσωπικό σας δεδομένο, ακόμα και αν δεν μπορούμε να σας ταυτοποιήσουμε μόνοι μας με βάση το στοιχείο αυτό,
           <br/>
           • η διεύθυνση (URL) την οποία επιθυμείτε να προσπελάσετε και η σχετική ημερομηνία
           <br/>
           • αρχείο σφαλμάτων
           <br/>
           Τα παραπάνω στοιχεία συλλέγονται για τον έλεγχο της ασφάλειας των πληροφοριών και υπηρεσιών του ιστοτόπου, για τη διασφάλιση της διαθεσιμότητας, ακεραιότητας και εμπιστευτικότητας των πληροφοριών και δεδομένων από τυχαίες ή παράνομες ή κακόβουλες ενέργειες ή συμβάντα, για τη διερεύνηση τυχόν διαδικτυακών επιθέσεων και περιστατικών και για την υποστήριξη τυχόν σχετικών νομικών αξιώσεων.
           <br/>
           Τα αρχεία καταγραφής μπορεί να κοινοποιηθούν στις εκτελούσες την επεξεργασία εταιρείες για το σκοπό της διαχείρισης του ιστότοπου και στις αρμόδιες αρχές σε περίπτωση που κρίνεται απαραίτητο για τη διερεύνηση τυχόν διαδικτυακής επίθεσης και περιστατικού.
           <br/>
           <br/> 
           Tελευταία αναθεώρηση: 31-10-2025      

        </p>
      ) : null}

  
    </Container>






    </>
  );
};

export default TermsOfUse;
